module.exports = __webpack_public_path__ + "static/media/diktat-4.3c907f24.mp3";